import { useState } from 'react'

export default function useFilters(initialState = {}) {
	const [filters, setFilters] = useState(initialState)

	const setFilter = (key, value) => {
		setFilters((prev) => ({
			...prev,
			[key]: value,
		}))
	}

	const clearFilters = () => setFilters({})
	return { filters, setFilter, clearFilters }
}
